// Helper para obter a logo do projeto
// Usa window.logoUrl (configurado via .env) ou fallback para logos padrão

export const getLogo = (variant = 'dark') => {
  // Para dark (background escuro) - usa window.logoUrl se disponível
  if (variant === 'dark') {
    if (typeof window !== 'undefined' && window.logoUrl) {
      return window.logoUrl;
    }
    return '/img/banner_w.png'; // Fallback para dark
  }
  // Para light (background claro)
  if (variant === 'light') {
    return '/img/banner_b.png';
  }
  // Fallback padrão
  return '/img/banner_w.png';
};

